<span>@if (displayIcon) {
  <svg-icon key="calendar"></svg-icon>
}{{formattedInterval}}</span>
